module.exports = __webpack_public_path__ + "static/consumo_back_crop.298c004a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/HeroHeader/img/consumo_back_crop.jpg
// module id = 584
// module chunks = 213534597649335